import React, { useEffect, useRef, useState } from 'react';
import './Premios.css';

const premios = [
  {
    id: 1,
    medalla: require('../assets/medallas-1.png'),
    tipo: 'Medalla de Oro',
    concurso: 'Concurso Internacional de Vinos',
    año: '2023',
    vino: 'Tannat Reserva 2020',
    descripcion: 'Reconocimiento a la excelencia en vinificación y calidad premium'
  },
  {
    id: 2,
    medalla: require('../assets/medallas-3.png'),
    tipo: 'Medalla de Plata',
    concurso: 'Wines of South America',
    año: '2023',
    vino: 'Chardonnay 2022',
    descripcion: 'Destacado por su elegancia y complejidad aromática'
  },
  {
    id: 3,
    medalla: require('../assets/medallas-4.png'),
    tipo: 'Gran Medalla de Oro',
    concurso: 'Berliner Wine Trophy',
    año: '2022',
    vino: 'Blend Premium',
    descripcion: 'Máximo galardón por el equilibrio perfecto de nuestro blend'
  },
  {
    id: 4,
    medalla: require('../assets/medallas-5.png'),
    tipo: 'Medalla de Oro',
    concurso: 'Catad\'Or Wine Awards',
    año: '2022',
    vino: 'Malbec Reserva',
    descripcion: 'Premiado por su estructura y potencial de guarda'
  },
  {
    id: 5,
    medalla: require('../assets/medallas-6.png'),
    tipo: 'Medalla de Bronce',
    concurso: 'Decanter World Wine Awards',
    año: '2021',
    vino: 'Cabernet Sauvignon',
    descripcion: 'Reconocimiento internacional a nuestra tradición'
  }
];

const Premios = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % premios.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const premio = premios[activeIndex];

  return (
    <section className="premios-showcase-section" ref={sectionRef}>
      <div className="premios-showcase-container">
        <div className="premios-showcase-header">
          <div className="badge-outline-premios">RECONOCIMIENTOS</div>
          <h2 className="premios-showcase-title">NUESTROS PREMIOS</h2>
          <p className="premios-showcase-subtitle">
            Calidad reconocida internacionalmente en los concursos más prestigiosos del mundo
          </p>
        </div>

        <div className={`premios-showcase-content ${isVisible ? 'visible' : ''}`}>
          {/* Medalla principal */}
          <div className="premio-showcase-main">
            <div className="premio-medalla-container">
              <img 
                src={premio.medalla} 
                alt={premio.tipo} 
                className="premio-medalla-grande"
                key={premio.id}
              />
              <div className="premio-glow"></div>
            </div>
          </div>

          {/* Información del premio */}
          <div className="premio-showcase-info">
            <div className="premio-año">{premio.año}</div>
            <h3 className="premio-tipo">{premio.tipo}</h3>
            <div className="premio-concurso">{premio.concurso}</div>
            <div className="premio-divider"></div>
            <div className="premio-vino-nombre">{premio.vino}</div>
            <p className="premio-descripcion">{premio.descripcion}</p>
          </div>

          {/* Miniatura de otros premios */}
          <div className="premios-thumbnails">
            {premios.map((p, index) => (
              <button
                key={p.id}
                className={`premio-thumbnail ${index === activeIndex ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
              >
                <img src={p.medalla} alt={p.tipo} />
                <div className="thumbnail-overlay">
                  <span>{p.tipo}</span>
                  <span>{p.año}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Premios;
